// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"style_wrapper_3PSHD","inner":"style_inner_1XWCO"};